import { mapActions, mapState } from 'vuex';
import ValidationMixin from '@/mixins/validation-mixin';

export default {
  mixins: [ValidationMixin],
  computed: {
    ...mapState('user', {
      user: (state) => state,
      isLoggedIn: (state) => state.loggedIn,
    }),
  },
  props: {
    stage: {
      default: null,
      type: Number,
    },
  },
  data() {
    return {
      ui: {
        loading: false,
      },
      validateFields: true,
      validateAll: false,
      serverValidationErrors: {},
    };
  },
  methods: {
    ...mapActions('user', {
      storeUpdateUser: 'updateUser',
    }),
    updateUser() {
      if (this.ui.loading) {
        return false;
      }

      this.ui.loading = true;

      this.validateAll = true;
      this.v$.$validate();

      if (this.validateFields && this.v$.$invalid) {
        this.ui.loading = false;
        this.$emit('register-stage:validation-error', { stage: this.$route.meta.index });
        return false;
      }

      this.serverValidationErrors = [];
      return this.storeUpdateUser(this.updatePayload)
        .then(() => {
          this.ui.loading = false;
          if (this.stage !== null) {
            this.$emit('register-stage:success', { stage: this.stage });
            return;
          }
          this.$emit('register-stage:success', { stage: this.$route.meta.index });
        })
        .catch((error) => {
          if (error.data.meta.length > 0) {
            error.data.meta.forEach((validationField) => {
              this.serverValidationErrors[validationField.field] = validationField.message;
            });
          }
          if (error.data.data.message) {
            this.serverValidationErrors.fail = error.data.data.message;
          }
          this.ui.loading = false;

          this.$emit('register-stage:error', { stage: this.$route.meta.index });
        });
    },
  },
};
